import configuration from './configuration';

const baseDomain = configuration.API_DOMAIN;

export const API_V1 = `${baseDomain}/api/v1`;
export const API_V2 = `${baseDomain}/api/v2`;
export const EMAIL_VERIFICATION_ENDPOINT = `${baseDomain}/api/v1/verify-email`;
export const BILLING_RATES_ENDPOINT = `${baseDomain}/api/v1/billingRates`;
export const FILES_ENDPOINT = `${baseDomain}/api/v1/files`;
export const MEDIA_ENDPOINT = `${baseDomain}/api/v1/media`;
export const REPORT_ENDPOINT = `${baseDomain}/api/v1/reports`;
export const POLICY_AUDITS_ENDPOINT = `${baseDomain}/api/v1/policyaudits`;
export const FINDINGS_ENDPOINT = `${baseDomain}/api/v1/findings`;
export const USER_ENDPOINT = `${baseDomain}/api/v1/user`;
export const USERS_ENDPOINT = `${baseDomain}/api/v1/users`;
export const USER_RESTRICTIONS_ENDPOINT = `${baseDomain}/api/v1/organizationHierarchy`;
export const REMOTE_ACCESS_ENDPOINT = `${baseDomain}/api/v1/remoteAccess`;
export const REMOTE_ACCESS_USERS_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/users`;
export const REMOTE_ACCESS_SESSIONS_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/sessions`;
export const AUTH0_ROLES_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/roles`;
export const AUTH0_USER_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/user`;
export const AUTH0_ASSIGNABLE_ROLES_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/assignableRoles`;
export const AUTH0_ADD_USER_ROLES_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/user/roles`;
export const AUTH0_ROLES_REFRESH_ALL_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/roles/refresh/all`;
export const JOBS_ENDPOINT = `${baseDomain}/api/v1/jobs`;
export const LOG_SYNC_ENDPOINT = `${baseDomain}/api/v1/logs/sync`;
export const LOG_SYNC_FILTERS_ENDPOINT = `${baseDomain}/api/v1/logs/sync/filters`;
export const BOUNCED_EMAILS_ENDPOINT = `${baseDomain}/api/v1/bouncedEmails`;
export const BOUNCED_EMAILS_FILTERS_ENDPOINT = `${baseDomain}/api/v1/bouncedEmails/filters`;
export const STORAGE_REPORT_ENDPOINT = `${baseDomain}/api/v1/storageReport`;
export const AUTH0_USERS_ROLES_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/users`;
export const AUTH0_USERS_ROLES_TOTALS_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/users/totals`;
export const AUTH0_USERS_ROLES_REMOVE_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/users/roles/remove`;
export const AUTH0_USERS_ROLES_NO_SITE_ACCESS_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/users/noSiteAccess`;
export const AUTH0_USERS_ROLES_BY_BUILDING_ENDPOINT = `${baseDomain}/api/v1/remoteAccess/auth0/users/building`;
export const USERS_ELIGIBLE_GROUPS_ENDPOINT = `${baseDomain}/api/v1/users/eligibleGroups`;
export const ORGANIZATION_ENDPOINT = `${baseDomain}/api/v1/organization`;
export const ORGANIZATIONS_ENDPOINT = `${baseDomain}/api/v1/organizations`;
export const ORGANIZATION_SERVICES_ENDPOINT = `${baseDomain}/api/v1/organization/services`;
export const ORGANIZATION_CONTACTS_ENDPOINT = `${baseDomain}/api/v1/organization/contacts`;
export const ORGANIZATION_HIERARCHY_ENDPOINT = `${baseDomain}/api/v1/organization/hierarchy`;
export const SERVICES_ENDPOINT = `${baseDomain}/api/v1/services`;
export const EVENTS_ENDPOINT = `${baseDomain}/api/v1/events`;
export const V2_EVENTS_ENDPOINT = `${baseDomain}/api/v2/events`;
export const EVENT_CATEGORIES_ENDPOINT = `${baseDomain}/api/v1/eventCategories`;
export const EVENT_CONFIGURATION_ENDPOINT = `${baseDomain}/api/v1/eventConfigurations`;
export const TICKET_ASSIGNMENTS_ENDPOINT = `${baseDomain}/api/v1/ticketAssignments`;
export const HOLIDAYS_ENDPOINT = `${baseDomain}/api/v1/holidays`;
export const DEVICES_ENDPOINT = `${baseDomain}/api/v1/devices`;
export const DEVICE_SYNC_CONFLICTS_ENDPOINT = `${baseDomain}/api/v1/devices/syncConflicts`;
export const BACKUP_DASHBOARD_ENDPOINT = `${baseDomain}/api/v1/devices/backupDashboard`;
export const ASSET_INVENTORY_ENDPOINT = `${baseDomain}/api/v1/assetInventory`;
export const ASSET_INVENTORY_V2_ENDPOINT = `${API_V2}/assetInventory`;
export const DEVICES_PAGINATION_ENDPOINT = `${baseDomain}/api/v1/devices/report`;
export const GATEWAY_PAGINATION_ENDPOINT = `${baseDomain}/api/v1/devices/report/gateways`;
export const DEVICES_CROSS_ORG_PAGINATION_ENDPOINT = `${baseDomain}/api/v1/devices/crossorganization`;
export const SOFTWARE_WHERE_FOUND_ENDPOINT = `${baseDomain}/api/v1/devices/software/whereFound`;
export const GATEWAY_CROSS_ORG_PAGINATION_ENDPOINT = `${baseDomain}/api/v1/devices/crossorganization/gateways`;
export const AWS_INSTANCES_ENDPOINT = `${baseDomain}/api/v1/aws/instances`;
export const AWS_KPI_ENDPOINT = `${baseDomain}/api/v1/aws/kpi`;
export const AWS_MONTHLY_COSTS_ENDPOINT = `${baseDomain}/api/v1/aws/costs/monthly`;
export const AWS_HIERARCHY_COST_ENDPOINT = `${baseDomain}/api/v1/aws/costs/hierarchy`;
export const AWS_STATUS_COST_ENDPOINT = `${baseDomain}/api/v1/aws/costs/byStatus`;
// Constant names corrected to "Ubiquiti" spelling, but the URL path segment
// stays "ubiquity" — that's the real, unrenamed route registered in
// totem-api (out of scope for this rename; changing it here would 404).
export const UBIQUITI_HOSTS_ENDPOINT = `${baseDomain}/api/v1/devices/ubiquity/hosts`;
export const UBIQUITI_SITES_ENDPOINT = `${baseDomain}/api/v1/devices/ubiquity/sites`;
export const CONFIGURATION_ENDPOINT = `${baseDomain}/api/v1/configuration`;
export const GLOBAL_CONTACTS_ENDPOINT = `${baseDomain}/api/v1/configuration/globalContacts`;
export const API_CONNECTIONS_ENDPOINT = `${baseDomain}/api/v1/configuration/connection`;
export const API_CONNECTION_TYPE_FIELDS_ENDPOINT = `${baseDomain}/api/v1/configuration/connectionTypeFields`;
export const TEMPERED_CONNECTION_TEST_ENDPOINT = `${baseDomain}/api/v1/configuration/connection/tempered/test`;
export const TEMPERED_AIRWALL_GROUPS_ENDPOINT = `${baseDomain}/api/v1/configuration/connection/tempered/airwallGroups`;
export const TEMPERED_AIRWALL_TAGS_ENDPOINT = `${baseDomain}/api/v1/configuration/connection/tempered/airwallTags`;
export const API_SITES_ENDPOINT = `${baseDomain}/api/v1/configuration/site`;
export const TICKET_ENDPOINT = `${baseDomain}/api/v1/ticket`;
export const TICKETS_ENDPOINT = `${baseDomain}/api/v1/tickets`;
export const QUEUES_ENDPOINT = `${baseDomain}/api/v1/queues`;
export const TICKET_DASHBOARD_ENDPOINT = `${baseDomain}/api/v1/ticketDashboard`;
export const OPS_TEAM_HUDDLE_ENDPOINT = `${baseDomain}/api/v1/opsTeamHuddle`;
export const PROJECT_HEALTH_ENDPOINT = `${baseDomain}/api/v1/projects`;
export const CONTRACTS_ENDPOINT = `${baseDomain}/api/v1/contracts`;
export const SALES_ORDER_ENDPOINT = `${baseDomain}/api/v1/salesOrder`;
export const SALES_ORDERS_ENDPOINT = `${baseDomain}/api/v1/salesOrders`;
export const NOZOMI_ENDPOINT = `${baseDomain}/api/v1/nozomi`;
export const NOZOMI_RECONCILIATION_ENDPOINT = `${baseDomain}/api/v1/nozomi/reconciliation`;
export const NOZOMI_VANTAGE_ASSET_COUNTS_ENDPOINT = `${baseDomain}/api/v1/nozomi/reconciliation/vantage`;
export const AUTO_COMPLETE_ENDPOINT = `${baseDomain}/api/v1/autoComplete`;
export const CONTROL_SYSTEM_REPORT = `${baseDomain}/api/v1/controlSystems/report`;
export const CYBER_REVIEW_REPORT = `${baseDomain}/api/v1/cyberReview`;
export const CONTROL_SYSTEMS_ENDPOINT = `${baseDomain}/api/v1/controlSystems`;
export const AGREEMENTS_ENDPOINT = `${baseDomain}/api/v1/agreements`;
export const END_OF_LIFE_ENDPOINT = `${baseDomain}/api/v1/endoflife`;
export const TOKEN_HEARTBEAT_ENDPOINT = `${baseDomain}/api/v1/token/heartbeat`;
export const TOKEN_REFRESH_ENDPOINT = `${baseDomain}/api/v1/token/refresh`;
export const AUTH_PROFILE_ENDPOINT = `${baseDomain}/api/v1/authProfile`;
export const LOGIN_PROFILE_ENDPOINT = `${baseDomain}/api/v1/loginProfile`;
export const AUTH_SESSION_EXCHANGE_ENDPOINT = `${baseDomain}/api/v1/auth/session`;
export const WIDGET_LAYOUT_ENDPOINT = `${baseDomain}/api/v1/widgets/layout`;
export const WIDGET_PALETTE_ENDPOINT = `${baseDomain}/api/v1/widgets/palette`;
export const WIDGET_COMPONENT_ENDPOINT = `${baseDomain}/api/v1/widgets/component`;
export const CONTACT_SEARCH_ENDPOINT = `${baseDomain}/api/v1/organization/contacts/search`;
export const ENERGY_ENDPOINT = `${baseDomain}/api/v1/energy`;
export const V2_CONTROL_SYSTEMS_ENDPOINT = `${baseDomain}/api/v2/controlSystems`;
export const V2_SURVEY_ENDPOINT = `${baseDomain}/api/v2/survey`;
export const V2_REGIONS_ENDPOINT = `${baseDomain}/api/v2/regions`;
export const BUILDINGS_ENDPOINT = `${baseDomain}/api/v1/buildings`;
export const V2_BUILDINGS_ENDPOINT = `${baseDomain}/api/v2/buildings`;
export const AUVIK_ENDPOINT = `${baseDomain}/api/v1/auvik`;
export const NINJA_ONE_ENDPOINT = `${baseDomain}/api/v1/ninja-one`;
export const SENTINEL_ONE_ENDPOINT = `${baseDomain}/api/v1/sentinel-one`;
export const COVE_DATA_PROTECTION_ENDPOING = `${baseDomain}/api/v1/coveDataProtection`;
export const NETSUITE_PENDING_ENDPOINT = `${baseDomain}/api/v1/netSuitePendingImports`;
export const TENANTS_ENDPOINT = `${ORGANIZATION_ENDPOINT}/tenants`;
export const UI_ENDPOINT = `${baseDomain}/api/v1/ui`;
export const RULES_ENDPOINT = `${baseDomain}/api/v1/rules/`;
export const DOCUMENTS_ENDPOINT = `${baseDomain}/api/v1/documents`;

export const UNAUTHENTICATED_VENDORS_ENDPOINT = `${baseDomain}/api/v0/vendors`;

export const UNAUTHENTICATED_TICKET_ENDPOINT = `${baseDomain}/na/api/v1/ticketing`;
export const UNAUTHENTICATED_SURVEY_ENDPOINT = `${baseDomain}/na/api/v1/survey`;
export const ACCOUNT_PLAN_ENDPOINT = `${baseDomain}/api/v1/accountPlan`;
